import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import RepairProfileModal from './RepairProfileModal';
import {submitRepairProfileAction, endRepairProfileAction} from '../../../actions';

const mapStateToProps = state => {
  const {currentUser, repairingProfile, repairProfileSubmitted} = state.userManagement;
  return repairingProfile ? {
    modalOpen: repairingProfile,
    repairing: repairProfileSubmitted,
    email: currentUser.email
  } : {};
};

const mapDispatchToProps = dispatch => bindActionCreators({
  confirm: submitRepairProfileAction,
  cancel: endRepairProfileAction
}, dispatch);

const RepairProfileModalContainer = connect(mapStateToProps, mapDispatchToProps)(RepairProfileModal);

export default RepairProfileModalContainer;



// WEBPACK FOOTER //
// ./public/pages/UserManagement/UserDetailPage/modals/RepairProfileModal/RepairProfileModalContainer.js